export const FILE_RESIZE_OPTION = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1024,
};
